import * as Yup from 'yup';

export const codeSchema = Yup.string().required().default('')
  .label('Code');
